(function () {
'use strict';

angular
    .module('surveyCampaignOwnerRoutes', [
        'surveyCampaignControllers'
    ])
    .config(routeur);

    routeur.$inject = ['$stateProvider', '$urlRouterProvider'];

    function routeur($stateProvider, $urlRouterProvider) {
        $stateProvider

            .state('survey.campaign.slug.owners', {
                url: '/Owner',
                resolve: {
                    owners: ['$stateParams', 'surveyCampaignService', function ($stateParams, service) {
                        return service.getCampaignOwners($stateParams);
                    }],
                },
                views: {
                    'mainContent@survey': {
                        templateUrl: require('./campaignOwnersList.tpl.html'),
                        controller: 'CampaignOwnersListController',
                    }
                }
            });

    }
})();